import { useNavigate } from "react-router-dom";

import type { UseTwoFactorActionResult } from "@/shared/hooks/useTwoFactorAction";

import { TwoFactorChallengeModal } from "./TwoFactorChallengeModal";
import { TWO_FACTOR_SETTINGS_PATH, TwoFactorRequiredModal } from "./TwoFactorRequiredModal";

export interface TwoFactorActionModalsProps {
  controller: Pick<UseTwoFactorActionResult<unknown>, "challenge" | "required">;
  /** Translated sentence naming the action, shown when the user still has to enrol. */
  requiredDescription: string;
  challengeTitle?: string;
  challengeDescription?: string;
  /** What the prompt says to someone confirming with the security PIN; see `TwoFactorChallengeModal`. */
  challengePinDescription?: string;
}

/**
 * The two dialogs `useTwoFactorAction` drives, mounted once next to the action they guard. A member who
 * creates a security PIN in the enrolment notice lands in the challenge of the same action, with nothing to
 * redo.
 */
export function TwoFactorActionModals({
  controller,
  requiredDescription,
  challengeTitle,
  challengeDescription,
  challengePinDescription,
}: TwoFactorActionModalsProps) {
  const navigate = useNavigate();

  return (
    <>
      <TwoFactorChallengeModal
        open={controller.challenge.open}
        onOpenChange={controller.challenge.onOpenChange}
        onSubmit={controller.challenge.onSubmit}
        title={challengeTitle}
        description={challengeDescription}
        pinDescription={challengePinDescription}
      />
      <TwoFactorRequiredModal
        open={controller.required.open}
        onOpenChange={controller.required.onOpenChange}
        description={requiredDescription}
        onGoToSettings={() => {
          controller.required.onOpenChange(false);
          navigate(TWO_FACTOR_SETTINGS_PATH);
        }}
        onEnrolled={controller.required.onEnrolled}
      />
    </>
  );
}
